<template>
  <div>
    <template v-if="loading">
      <svgicon name="refresh" class="spin block mx-auto w-24 h-24 text-gray-light"/>
    </template>
    <template v-else>
      <div class="report-title flex flex-col items-center justify-center py-4">
        <vue-button icon="print-solid"
                    icon-class="svg-md"
                    v-if="hasReport"
                    @click="print"
                    class="btn btn-primary rounded-full"/>
        <h2 class="text-center text-black">
          <span v-html="title"></span>
          <small class="block text-sm" v-text="description"></small>
        </h2>
      </div>
      <div v-if="hasReport">
        <slot :report="report" :print="print"></slot>
      </div>
      <p v-else class="text-center">
        Aucune donnée disponible.
      </p>
    </template>
  </div>
</template>

<script>
/* globals axios route moment */

import { chunk } from 'lodash';
import ErrorHandler from '../../core/ErrorHandler';

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    perPage: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      canvas: null,
      report: null,
      loading: false,
      params: new URLSearchParams(window.location.search),
    };
  },

  created() {
    this.fetch();


  },

  computed: {
    title() {
      return `Rapport &laquo; ${this.getTranslatedType(this.type)} &raquo;`;
    },

    description() {
      const [start, end] = this.params
        .get('pickupDate')
        .split(',')
        .map(date => moment(date));

      if (end && !start.isSame(end)) {
        return `du ${start.format('ddd DD/MM')} au ${end.format('ddd DD/MM')}`;
      }

      return `du ${start.format('ddd DD/MM')}`;
    },

    hasReport() {
      if (!this.report) {
        return false;
      }
      if (typeof this.report === 'object' && Object.keys(this.report).length) {
        return true;
      }
      if (Array.isArray(this.report) && this.report.length) {
        return true;
      }
      return false;
    },
  },

  methods: {
    fetch() {
      this.loading = true;

      if (!this.params.has('pickupDate')) {
        this.params.set(
          'pickupDate',
          moment()
            .add(1, 'day')
            .format('YYYY-MM-DD'),
        );
      }

      axios
        .post(
          `${route('reports.orders.show', this.type)}?${this.params.toString()}`,
        )
        .then(({ data }) => {
          this.loading = false;
          this.report = this.perPage ? chunk(data, this.perPage) : data;
        })
        .catch((error) => {
          this.loading = false;
          new ErrorHandler(error).dispatch();
        });
    },

    refresh() {
      this.fetch();
    },

    print() {
      return window.print();
    },

    getTranslatedType(type) {
      const translation = {
        vendor: 'Vendeur',
        labels: 'Etiquettes',
        lab: 'Laboratoire',
      };

      return translation[type] || '';
    },
  },
};
</script>
